import MessagingHelpers from "./helpers";
import scrollChatDown from "./scroll_chat_down";

function getChatComment(chatId, commentId, callback) {
  console.log(`get comment ${commentId}`);
  $.ajax({
    url: `/admin/chats/${chatId}/chat_comments/${commentId}`,
    dataType: "html",
    success: callback,
    error: (jqXHR, textStatus, errorThrown) => {
      console.log(`comment ${commentId} ${errorThrown}`);
    },
  });
}

function getChat(chatId, callback) {
  console.log(`get chat ${chatId}`);
  $.ajax({
    url: `/admin/chats/${chatId}`,
    dataType: "html",
    success: callback,
    error: (jqXHR, textStatus, errorThrown) => {
      console.log(`chat ${chatId} ${errorThrown}`);
    },
  });
}

export default function ChatRender(chat) {
  this.helpers = new MessagingHelpers();
  this.chat = chat;
  this.userId = parseInt(document.body.dataset.userId);

  this.commentsContainer = () => document.getElementById("comments-container");

  this.refreshChat = () => {
    getChat(this.chat.chatId, (data) => {
      this.commentsContainer().innerHTML = data;
      scrollChatDown();
    });
  };

  this.renderSingleDeletedMessage = (data) => {
    let comment = this.getCommentById(data.comment.id);

    // Delete message if present in chat
    if (comment) {
      comment.remove();
      let deletedMessage = this.renderDeletedComment(data.comment);
      let container = $("#deleted-messages .list-group");
      container.append(deletedMessage);
    }
  };

  this.fetchAndReplaceComment = (data) => {
    let comment = data.data.comment;
    getChatComment(this.chat.chatId, comment.id, (data) => {
      this.replaceComment(comment.id, data);
    });
  };

  this.replaceComment = (commentId, html) => {
    if ($("#hidden_chat_id").val() !== this.chat.chatId) {
      return false;
    }

    let previousComment = this.getCommentById(commentId);
    if (previousComment) {
      $(previousComment).replaceWith(html);
    } else {
      this.addComment(html);
    }
  };

  this.addComment = (comment) => {
    $(this.commentsContainer()).append(comment);
    scrollChatDown();
  };

  this.renderDeletedComment = (message) => {
    let system = "";
    if (message.is_system) {
      system = `<span class="badge badge-primary mr-1">system</span>`;
    }
    let timestamp = new Date(message.created_at);

    const dateOptions = { year: "numeric", month: "long", day: "numeric" };
    return `
      <div class="list-group-item list-group-item-danger">
        <small>Deleted by: ${message.deleted_by || "Bot"} at ${timestamp.toLocaleTimeString(
      "nl-NL",
      dateOptions
    )}</small>
        <div>
          <div class="author-name">${message.author.full_name} | ${
      message.author.organization.name
    }</div>
        <p class="mb-0">
          <small class="mr-2">${timestamp.toLocaleTimeString("nl-NL")}</small>
          ${system}
          <span>${this.helpers.safeHtml(message.content)}</span>
        </p>
        </div>
      </div>`;
  };

  this.getCommentById = (id) => {
    return document.getElementById(`comment-item-${id}`);
  };
}
